// TIP-487 (MV Stage 1b) — global "acting as company" identity.
// Membership is per company, so the app needs to know which of the user's
// companies they are currently acting as. Persisted to localStorage so the
// choice survives a reload; cleared on logout (authSlice.clearUserInfo already
// removes this key).
import { createSlice } from "@reduxjs/toolkit";

export const STORAGE_KEY = "userSelectedCompany";

export const loadActiveCompany = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    return null;
  }
};

const initialState = {
  activeCompany: loadActiveCompany(),
};

const activeCompanySlice = createSlice({
  name: "activeCompany",
  initialState,
  reducers: {
    setActiveCompany: (state, action) => {
      state.activeCompany = action.payload;
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(action.payload));
      } catch (err) {
        // ignore write errors
      }
    },
    clearActiveCompany: (state) => {
      state.activeCompany = null;
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (err) {
        // ignore
      }
    },
  },
});

export const { setActiveCompany, clearActiveCompany } = activeCompanySlice.actions;

export const selectActiveCompany = (s) => s.activeCompany.activeCompany;
export const selectActiveCompanyId = (s) => s.activeCompany.activeCompany?.companyID ?? null;

export default activeCompanySlice.reducer;
